import { SocketContextPortal } from './context/portalSocketContext';
import { SocketContextSentinel } from './context/sentinelSocketContext';
import { useSocket } from './useSocket';

/** A hook that returns whether or not the socket clients are connected. */
export const useSocketConnected = () => {
  const { connected: portal } = useSocket(SocketContextPortal, undefined);
  const { connected: sentinel } = useSocket(SocketContextSentinel, undefined);

  return portal && sentinel;
};
